<tx-unauthenticated-pages-wrapper>
  <div class="logout-container">
    <p><strong>You are logged out from the Editor session.</strong></p>
    <p>
      You can now close this tab or click
      <a href="/login">here</a>
      to login again.
    </p>
  </div>
</tx-unauthenticated-pages-wrapper>
